<template>
    <div class="ngdialog-content">
        <dialog-header>
            <h4>{{ $t('systems.parameter_logs.create_textentry') }}</h4>
        </dialog-header>

        <form name="labelsForm" novalidate @submit.prevent="submitHandler" class="form">
            <div class="ngdialog__body">
                <fieldset class="form__group">
                    <div class="row form__row">
                        <label class="form__label" for="node_id">{{ $t('fields.function') }}</label>
                        <select class="form__field" v-model="component_index">
                            <option
                                v-for="(o, i) in components"
                                :key="i"
                                :value="i"
                                :label="o.name"
                                >{{ o.name }}</option
                            >
                        </select>
                    </div>

                    <div class="row form__row">
                        <label class="form__label" for="text">{{ $t('fields.text') }}</label>
                        <textarea
                            type="text"
                            class="form__field resize-vertical"
                            rows="5"
                            id="text"
                            name="text"
                            v-model.trim="$v.formData.value.$model"
                            :class="{
                                'is-invalid': $v.formData.value.$invalid,
                                'is-dirty': $v.formData.value.$dirty,
                            }"
                        ></textarea>
                    </div>

                    <div class="row form__row">
                        <label class="form__label" for="label">{{
                            $t('fields.organization')
                        }}</label>
                        <select class="form__field" v-model="formData.organization_id">
                            <option
                                v-for="o in availableOrganizations"
                                :key="o.id"
                                :value="o.id"
                                :label="o.name"
                                >{{ o.name }}</option
                            >
                        </select>
                    </div>
                </fieldset>
            </div>

            <dialog-buttons :submit-text="$t('buttons.save')" :disabled="loading" />
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import * as api from '@/api';
import DialogHeader from '@/components/DialogHeader';
import DialogButtons from '@/components/DialogButtons';
import { required } from 'vuelidate/lib/validators';

export default {
    components: {
        DialogHeader,
        DialogButtons,
    },
    props: {
        systemId: {
            type: [Boolean, String],
            default: false,
        },
        organizations: {
            type: [Boolean, Array],
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            components: [],
            component_index: 0,
            formData: {
                oid: '',
                node_id: '',
                value: '',
                organization_id: '',
                fctId: '',
            },
        };
    },
    computed: {
        ...mapState(['userData']),
        availableOrganizations() {
            const organizations = [...this.organizations];
            const userOrganizationId =
                this.userData.organization && this.userData.organization.id
                    ? this.userData.organization.id
                    : false;
            if (userOrganizationId) {
                const userOrganizationExists = this.organizations.find(
                    o => o.id === userOrganizationId
                );
                if (!userOrganizationExists) {
                    organizations.push(this.userData.organization);
                }
            }
            return organizations;
        },
    },
    validations() {
        return {
            formData: {
                value: {
                    required,
                },
            },
        };
    },
    mounted() {
        this.loadAvailableData();
        if (this.userData.organization && this.userData.organization.id) {
            this.formData.organization_id = this.userData.organization.id;
        }
    },
    methods: {
        submitHandler() {
            if (this.$v.formData.$invalid) {
                this.$v.formData.$touch();
                return;
            }
            this.addTextEntry();
        },
        async loadAvailableData() {
            try {
                const response = await api.systems.components({ id: this.systemId });
                this.components = response.data.components;
            } catch (error) {
                console.error(error);
            }
        },
        async addTextEntry() {
            this.loading = true;

            let c = this.components[this.component_index];
            this.formData.node_id = c.node_id;
            this.formData.fctId = c.fctId;

            this.formData.oid = `/1/${this.formData.node_id}/${this.formData.fctId}/63/127/0`;

            try {
                const response = await api.systems.datapointLogsCreate({
                    id: this.systemId,
                    data: this.formData,
                });
                if (response) {
                    this.loading = false;
                    this.$emit('close');
                }
            } catch (error) {
                console.error(error);
                this.$notify({
                    type: 'error',
                    text: this.$t('systems.parameter_logs.error_create_textentry'),
                });
            }
        },
    },
};
</script>
